module.exports = __webpack_public_path__ + "img/stopSearch.364318b0.png";